import { HiWrenchScrewdriver } from "react-icons/hi2";

const ToBeUpdated = () => {
  return (
    <div className="min-h-screen flex justify-center items-center rounded-full pb-44">
      <div className="text-7xl font-display flex gap-8 text-gray-200 font-bold border-8 border-gray-200 p-20 rounded-full">
        <HiWrenchScrewdriver />
        To be updated.
      </div>
    </div>
  );
};

export default ToBeUpdated;
